import React, {Component} from 'react';
import {Helmet} from "react-helmet";
import {Breadcrumb} from 'semantic-ui-react';
import {Link} from 'react-router-dom';

import CustomDivider from '../../components/extras/CustomDivider';
import ClientList from "../../components/contacts/ClientList";

class Clients extends Component {

    render() {
        return (
            <div>
                <Helmet>
                    <title>Clientes | Contactos - Bisttros</title>
                </Helmet>
                <Breadcrumb>
                    <Breadcrumb.Section as={Link} to='/contacts'>Contactos</Breadcrumb.Section>
                    <Breadcrumb.Divider/>
                    <Breadcrumb.Section active>Clientes</Breadcrumb.Section>
                </Breadcrumb>
                <CustomDivider/>
                <ClientList/>
            </div>
        );
    }
}

export default Clients;


// WEBPACK FOOTER //
// ./src/containers/contacts/Clients.js